<template>
    <v-container fluid dark flat>
        <div class="overlay-loading">
            <img src="../../../../assets/static/img/logo-demosle.png" style="max-height: 100px"/>
            <h3 style="color:#9D4593">{{mensaje}}</h3>
        </div>
        <v-snackbar
			v-model="messageContact.show"
			:color="messageContact.type"
			right
			:timeout="4000"
			top>
			{{ messageContact.text }}
			<v-btn
				color="white"
				flat
				@click="messageContact.show = false">
				Ok
			</v-btn>
		</v-snackbar>
    </v-container>
</template>
<script>
import { EventBus } from '../../../../events.js'
import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/functions'
export default {
    data() {
        return {
            mantenedores: {},
            allData: {
				first: {
					distancia: {},
					direccion_origen: {},
					direccion_destino: {}
				}
			},
            firstData: {
				distancia: {}
			},
            secondData: {},
            dataPersonalF: {
				nombre: '',
                telefono: '',
                email: '',
            },
            datos: {
                origen: {},
                destino: {}
            },
            alreadyCalculated: false,
            mensaje: 'Estamos procesando la información de tu pedido.',
            messageContact: {
                show: false,
                type: '',
                text: ''
            },
            idTrp: ''
        }
    },
    methods: {
        get_mantenedores(){
            let db = firebase.firestore()
            let self = this
            db.collection("mantenedores").doc("mantenedores").get().then(function(doc) {
                    if (doc.exists) {
                            self.mantenedores = doc.data()
                            //self.initHoursPicker()
                            EventBus.$emit('emmitMantenedoresDemo', self.mantenedores);
                    } else {
                            // doc.data() will be undefined in this case
                            console.log("No such document!");
                    }
            }).catch(function(error) {
                    console.log("Error getting document:", error);
            });
        },
        tiempoCarga(elementos){
            let volumen = 0
            elementos.forEach(function(item){
                volumen += item.metros * item.qty
            })
            return Math.round( (volumen * this.mantenedores.vol_tiempo) * 100 ) / 100
        },
        countItems(){
            const here = this
            this.elementsQty = 0
            this.secondData.map(function(element){ 
                here.elementsQty = here.elementsQty + element.qty
            })
        },
        savePedido(){
            const here = this
            let finalData = {
                first: this.firstData,
                second: this.secondData,
                third: this.datos,
                basicoValue: this.allData.baseValue,
                completoValue: 0,
                finalValue: this.allData.baseValue,
                pedidoID: '',
                servicio: 'Básico'
            }
            EventBus.$emit('finalValueDemo', finalData)
            /* setTimeout(function() {
                here.finalCalc()
            }, 800); */
        },
        initCalc(dialog = true) {
				try {this.loadingFinalValue = true
				// this.dialogDatosPersonales = true
				this.dialogPersonalesValidate ? this.dialogDatosPersonales = true : this.dialogDatosPersonales = false
				console.log('allData.first.distancia')
				console.log(this.allData.first.distancia)
				this.allData.tiempos = {
					distancia: Math.round(this.allData.first.distancia.duration.value/60),
					carga: this.tiempoCarga(this.allData.second)
				} 
				this.allData.fecha_servicio_obj = new Date(this.allData.first.date + 'T' + this.allData.first.time)
				this.allData.needDistanceCalc = true
				const baseValue = firebase.functions().httpsCallable('initialCalc')
				baseValue({data: this.allData})
				.then(({data}) =>{
					this.allData.baseValue = data
					// this.setAjusteMudanza(1)
					// this.getRoute()
					this.countItems()
					this.savePedido()
					// EventBus.$emit('mudanzaThird');
				})
				.catch(httpsError => {
					this.loadingFinalValue = false
					// this.getRoute()
					this.countItems()
                    console.log(httpsError)
				})
			} catch (error) {
				console.log(error)
			}
            
        },
        finalCalc(retries = 0){
            let finalData = this.allData
            finalData.idPedido = this.pedidoID
            // this.loadingFinalValue = true
            this.errorPrice = false
            finalData.needDistanceCalc = true
            const baseValue = firebase.functions().httpsCallable('addAddressValue')
            baseValue({data: finalData})
            .then(({data}) =>{
                this.allData.finalValue = data
                if(this.allData.finalValue.amount < this.allData.baseValue.amount){this.allData.finalValue.amount = this.allData.baseValue.amount}
                this.loadingFinalValue = false
                // this.setAjusteMudanza(2)
                // this.getRoute()
                this.countItems()
				if (!this.alreadyCalculated) {
					this.validate()
				}
                // this.getNsToSendEmail()
            })
            .catch(httpsError => {
                console.log('Error en addAddressValue')
                console.log(httpsError)
                if(retries < 3){
                    const retry = retries + 1
                    this.finalCalc(retry)
                }
                else{
                    this.loadingFinalValue = false
                    this.errorPrice = true
                    // this.getRoute()
                    this.countItems()
                    this.validate()
                }
            })
        },
        sendDemoMail() {
            const here = this
            const data = {
                idPedido: this.pedidoID,
                transportista: this.idTrp
            }
            const sendDemoMail = firebase.functions().httpsCallable('sendDemoMail')
            sendDemoMail(data)
            .then(({data}) => {
                here.messageContact.show = true
				here.messageContact.type = 'success'
				here.messageContact.text = 'Se ha enviado correctamente el mensaje, nos pondremos en contacto contigo a la brevedad.'
            })
            .catch(httpsError => {
                console.log('Error en sendDemoMail')
                console.log(httpsError)
                here.messageContact.show = true
                here.messageContact.type = 'error'
                here.messageContact.text = 'Debe ingresar direccion de destino y origen.'
            })
        },
        validate(){
            const finalDataSave = {
                first: this.allData.first,
                second: this.allData.second,
                third: this.allData.third,
                basicoValue: this.allData.baseValue,
                completoValue: this.allData.finalValue,
                finalValue: this.allData.finalValue,
                pedidoID: this.pedidoID,
                servicio: "Completo"
            }
			this.alreadyCalculated = true
            this.mensaje = 'Hemos procesado tu solicitud, tu transportista se pondrá en contacto a la brevedad'
            this.sendDemoMail()
            EventBus.$emit('finalValueDemo', finalDataSave)
        },
        
        sortElement(){
            const here = this
            this.sortedElements = []
            this.allData.second.map(function(item) {
                let index = here.sortedElements.findIndex(x => x.cat == item.cat)
                if(index == -1){
                    here.sortedElements.push({ cat: item.cat, elements: [] })
                    const newIndex = here.sortedElements.length - 1
                    here.sortedElements[newIndex].elements.push(item)
                }
                else{
                    here.sortedElements[index].elements.push(item)
                }
            });
        },
    },
    mounted() {
        this.get_mantenedores()
        EventBus.$on('enterMudanzaFourthDemo', data => {
			this.allData = {}
            this.allData = data
            this.firstData.distancia = data.first.distancia
			if (data.dialogPersonalesValidate) {
				this.dataPersonalF.email = data.dataPersonal.email
				this.dataPersonalF.telefono = data.dataPersonal.telefono
				this.dialogPersonalesValidate = false
			}
            this.sortElement()
			this.loadingFinalValue = true
            this.initCalc()
            
        })
        EventBus.$on('mudanzaSecondDemo', data => {
            this.secondData = data.datos
            // this.textTiempo()
        })
        EventBus.$on('mudanzaFirstDemo', data => {
            if (!data.directions) {
                this.firstData = data.datos
            } else {
                this.firstData.direccion_origen.direccion = data.direccion_origen.direccion
                this.firstData.direccion_destino.direccion = data.direccion_destino.direccion
            }
        })
		
        EventBus.$on('idPedidoDemo', data => {
            this.pedidoID = data.pedidoID
			this.finalCalc()
        })
		EventBus.$on('idPedidoRetomarDemo', data => {
			this.pedidoID = data.pedidoID
		})
		EventBus.$on('retomarPedidoFourthDemo', async data => {
			console.log(data.ajuste_mudanza)
			this.allData = data
			this.dataPersonalF.email = data.first.personales.email
			this.dataPersonalF.telefono = data.first.personales.telefono
			this.direcciones.origen = data.first.direccion_origen.direccion
			this.direcciones.destino = data.first.direccion_destino.direccion
			const dataDireccion = {
				direcciones: this.direcciones
			}
			this.secondData = data.second
			this.firstData = data.first
			this.countItems()
			await this.setAddress(dataDireccion)
			await this.getRoute()
			this.loadingFinalValue = false
			this.continuar = false
		})
        EventBus.$on('transportFound', data => {
            this.idTrp = data.id
            console.log('idTransportista ' + this.idTrp)
        })
    }
}
</script>